import { contains, compose, evolve, map, sort } from 'ramda';

const getDate = date => (
    date === '-1' ? null : date
);

export default data => {
    return {
        ...data,
        stages: compose(
            map(evolve({
                date: {
                    from: getDate,
                    to: getDate,
                },
            })),
            sort((stageA, stageB) => {
                const parentId = stageB.parent || stageB.parentId;
                const closeIds = [stageA.id, stageA.parent, stageA.parentId];

                if (!parentId || contains(parentId, closeIds)) {
                    return 0;
                } else {
                    return parentId;
                }
            })
        )(data.stages),
    };
};
